import { render, staticRenderFns } from "./DietStatus.vue?vue&type=template&id=2a6b10ae"
import script from "./DietStatus.vue?vue&type=script&lang=js"
export * from "./DietStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports